module.exports = __webpack_public_path__ + "static/img/signin_banner.c8f5fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/signin_banner.jpg
// module id = qFld
// module chunks = 1